function resolveArray(value) {
  return Array.isArray(value) ? value : [];
}

function resolveText(value) {
  return String(value ?? '').trim();
}

function actionKey(action) {
  if (typeof action === 'string') {
    return resolveText(action);
  }
  if (!action || typeof action !== 'object' || Array.isArray(action)) {
    return '';
  }
  return resolveText(action.action_key || action.key || action.action);
}

function tabSupportsEdit(tab = {}) {
  return resolveArray(tab?.toolbar_actions || tab?.toolbarActions)
    .some((action) => actionKey(action) === 'edit');
}

export function resolveCanvasInlineEditState({
  activeTabKey = '',
  canvasManualControlsEnabled = false,
  canvasTabs = [],
} = {}) {
  const tabKey = resolveText(activeTabKey);
  const activeTab = resolveArray(canvasTabs)
    .find((tab) => resolveText(tab?.key) === tabKey);
  return {
    activeTabKey: tabKey,
    enabled: Boolean(canvasManualControlsEnabled && activeTab && tabSupportsEdit(activeTab)),
  };
}

export default resolveCanvasInlineEditState;
